import { __assign, __spreadArray } from "tslib";
import * as React from 'react';
import { ChatItem } from './ChatMessage.js';
import { InputField } from '../../forms/index.js';
import { Button } from '../Button/index.js';
var empty = React.createElement(React.Fragment, null);
function scrollToBottom(container) {
    if (container) {
        container.scrollTop = container.scrollHeight;
    }
}
export var Chat = function (_a) {
    var messages = _a.messages, readonly = _a.readonly, onSend = _a.onSend;
    var _b = React.useState(''), newMessageContent = _b[0], setNewMessageContent = _b[1];
    var immutableMessages = React.useMemo(function () { return __spreadArray([], messages, true).sort(function (a, b) { return a.sequence - b.sequence; }); }, [messages]);
    var disabled = !newMessageContent;
    var containerRef = React.useRef(null);
    React.useEffect(function () {
        scrollToBottom(containerRef.current);
    }, [messages]);
    var send = function (e) {
        !disabled && onSend(newMessageContent);
        e.preventDefault();
        setNewMessageContent('');
    };
    return (React.createElement("div", { className: "chat-container" },
        React.createElement("div", { ref: containerRef, className: "chat-messages-container" },
            React.createElement(React.Suspense, { fallback: empty }, immutableMessages.map(function (message) { return (React.createElement(ChatItem, __assign({ key: message.sequence }, message))); }))),
        !readonly && (React.createElement("form", { "aria-disabled": disabled, onSubmit: send },
            React.createElement(InputField, { label: "New Message", value: newMessageContent, onChange: setNewMessageContent }),
            React.createElement(Button, { disabled: disabled }, "Send Message")))));
};
//# sourceMappingURL=Chat.js.map